/**
 * Today in the browser's own timezone, as the yyyy-mm-dd a date input takes.
 * `toISOString()` gives the UTC date, which in Kampala is still yesterday until 3 a.m.
 */
export const todayIso = (now: Date = new Date()): string =>
  new Date(now.getTime() - now.getTimezoneOffset() * 60_000).toISOString().slice(0, 10);

/** Now in the browser's own timezone, as the yyyy-mm-ddThh:mm a datetime-local input takes. */
export const nowLocalInput = (now: Date = new Date()): string =>
  new Date(now.getTime() - now.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);

/** A day some whole days from today, in the browser's own timezone. */
export const daysFromTodayIso = (days: number, now: Date = new Date()): string => {
  const then = new Date(now);
  then.setDate(then.getDate() + days);
  return todayIso(then);
};
